import Navbar from "./Navbar";
import Footer from "./Footer";
import { ApplicationJourneySection, TOTAL_APPLICATION_STEPS } from "./ApplicationJourney";
import { APPLICATION_URL } from "../utils/appLinks";

const requirements = [
  "Salaried, with a monthly take-home salary of ₹35,000 or more",
  "PAN Card and Aadhaar Card",
  "Bank statement and salary slips",
  "The mobile number linked to your Aadhaar",
];

const ApplyNow = () => {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />

      <section className="pt-28 pb-10 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl xl:text-5xl font-bold text-[#CC1A1A] tracking-tighter mb-4 leading-tight">
            Apply For Your Loan
          </h1>
          <p className="text-gray-500 text-base lg:text-lg mb-8">
            The application is fully online and has {TOTAL_APPLICATION_STEPS} steps. Keep these ready before
            you start.
          </p>

          <ul className="flex flex-col gap-3 text-left max-w-xl mx-auto mb-8">
            {requirements.map((requirement) => (
              <li key={requirement} className="flex items-start gap-3 text-gray-700 text-base">
                <span className="w-1.5 h-1.5 rounded-full bg-[#CC1A1A] mt-2.5 flex-shrink-0" />
                {requirement}
              </li>
            ))}
          </ul>

          <a
            href={APPLICATION_URL}
            className="inline-block px-8 py-3.5 bg-[#CC1A1A] text-white text-sm tracking-widest uppercase hover:bg-red-800 transition-colors rounded text-center"
          >
            START APPLICATION
          </a>
        </div>
      </section>

      <ApplicationJourneySection ctaHref={APPLICATION_URL} ctaLabel="START APPLICATION" />
      <Footer />
    </div>
  );
};

export default ApplyNow;
